export const rtiTranslations = {
  en: () =>
    import('@core/integrations-legacy/locales/en.json').then(translations => ({
      en: translations.default,
    })),
  de: () =>
    import('@core/integrations-legacy/locales/de.json').then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import('@core/integrations-legacy/locales/fr.json').then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import('@core/integrations-legacy/locales/nl.json').then(translations => ({
      nl: translations.default,
    })),
  sv: () =>
    import('@core/integrations-legacy/locales/sv.json').then(translations => ({
      sv: translations.default,
    })),
  fi: () =>
    import('@core/integrations-legacy/locales/fi.json').then(translations => ({
      fi: translations.default,
    })),
};
